import React from 'react';

import ActionTileView from '../ActionTile.View';
import {ReviewActionModel} from './ReviewAction.model';

export default React.memo(function ReviewActionView({
  label,
  hint,
  disabled,
  onPress,
}: ReviewActionModel) {
  return (
    <ActionTileView
      testID="v2-action-review"
      icon="chart"
      label={label}
      hint={hint}
      disabled={disabled}
      onPress={onPress}
    />
  );
});
